export type Project = {
  id: string;
  team: string;
  year: number;
  wikiUrl: string;
  articleIds: string[];
  public: boolean;
  // Full titles of the linked preprints (admin payload), so a picker can
  // show "2026 · Team — Title".
  preprints?: { articleId: string; title: string }[];
  title?: string;
};
export type FeatureFields = {
  headline: string;
  summary: string;
  imageUrl: string;
  imageAlt: string;
  imageCredit: string;
  featured: boolean;
  sortOrder: number;
  rightsNote: string;
};
export type Story = Project &
  FeatureFields & {
    articles: { articleId: string; title: string; url: string }[];
    hasInsight: boolean;
    imageKind: "insight" | "wiki" | "placeholder";
    relatedArticles: null | { count: number; url: string };
  };
export type Paper = {
  articleId: string;
  title: string;
  authors: string[];
  team: string;
  year: number;
  date: string;
  url: string;
  abstract: string;
  wiki: string;
  wikiAvailable: boolean;
  wikiQuestion: string;
};
export type Page<T> = {
  items: T[];
  total: number;
  offset: number;
  limit: number;
};
export type EditorialRecord = {
  id: string;
  kind: "feature";
  projectId: string;
  draft: FeatureFields;
  published: FeatureFields | null;
  revision: number;
  publishedRevision: number | null;
  updatedAt: string;
  publishedAt: string | null;
};
export type Session = {
  user: null | { username: string; role: "editor" | "admin" };
  csrfToken: string | null;
  portalLogin?: string | null;
};
export type Preview = { kind: "feature"; story: Story; featured: Story[]; inHero: boolean };
// Code points, the same count Python's len() gives the server.
export function charCount(s: string) {
  return Array.from(s).length;
}
